import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { projects } from "../mockData";
import SEO from '../components/SEO';
import { seoConfig } from '../utils/seoConfig';

const Home = () => {
  // Force la mise à jour du titre au montage du composant
  useEffect(() => {
    console.log("Home mounted - Setting title to:", seoConfig.home.title);
    document.title = seoConfig.home.title;
  }, []);

  // On garde uniquement 3 projets : Cinéma, ALBUMS, TV/Web
  const homeProjects = [
   { ...projects.find((p) => p.id === 3), link: "/cinema", title: "CINÉMA" },
    { ...projects.find((p) => p.id === 5), link: "/musique", title: "ALBUMS/EP" },
    { ...projects.find((p) => p.id === 6), link: "/tvweb", title: "TV & WEB" },
  ];

  return (
    <>
      <SEO 
        title={seoConfig.home.title}
        description={seoConfig.home.description}
        keywords={seoConfig.home.keywords}
        url={seoConfig.home.url}
      />
      <div className="min-h-screen bg-black pt-10 sm:pt-12 md:pt-20 flex flex-col">

      {/* Hero */}
      <section
        className="relative flex flex-col items-center justify-center overflow-hidden text-center px-4
                   h-[55vh] sm:h-52vh] md:h-[45vh] lg:h-[44vh]"
      >
        <div
          className="absolute inset-0 opacity-50"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, rgba(0, 206, 209, 0.3) 0%, rgba(155, 89, 182, 0.2) 50%, transparent 100%)",
          }}
        />
        <div className="relative z-10">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-black text-white
                       tracking-tighter leading-[1.1] mb-3 sm:mb-4 md:mb-5"
          >
            CHARLES LUDIG
          </h1>

          <div className="space-y-1 sm:space-y-2">
            <p
              className="text-lg sm:text-xl md:text-3xl font-bold tracking-wide"
              style={{ color: "#00CCCC" }}
            >
              Compositeur
            </p>
            <p className="text-sm sm:text-base md:text-xl text-gray-300 font-light tracking-wide">
              <span style={{ color: "#DD99CC" }}>Technicien Son</span> ·{" "}
              <span style={{ color: "#00CC00" }}>Post-Production Audio</span>
            </p>
          </div>
        </div>
      </section>

      {/* Grille projets : 3 colonnes partout (responsive) */}
      <section
        className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8
                   -mt-16 sm:-mt-10 md:-mt-8 lg:mt-0
                   pb-10 sm:pb-12 md:pb-16"
      >
        <div
          className="
            grid grid-cols-3
            gap-3 sm:gap-5 md:gap-6 lg:gap-8
          "
        >
          {homeProjects.map((project) => (
            <Link
              key={project?.id}
              to={project?.link || "#"}
              aria-label={project?.title ? `Ouvrir ${project.title}` : "Ouvrir le projet"}
              className="group flex flex-col"
            >
              <div
                className="
                  relative overflow-hidden rounded-2xl
                  aspect-square
                  transform transition-all duration-500 group-hover:scale-[1.03]
                "
              >
                <img
                  src={project?.image}
                  alt={project?.title || "Projet"}
                  loading="lazy"
                  className="w-full h-full object-cover
                             transform transition-transform duration-700 group-hover:scale-110"
                />
                <div className="pointer-events-none absolute inset-0 rounded-2xl
                                border-2 border-transparent group-hover:border-cyan-400
                                transition-all duration-300" />
              </div>
              
              {/* Titre sous l'image */}
              <h3 className="mt-3 sm:mt-4 text-center text-white text-sm sm:text-base md:text-lg font-semibold
                             transition-colors duration-300 group-hover:text-cyan-400">
                {project?.title || "Projet"}
              </h3>
            </Link>
          ))}
        </div>
      </section>
    </div>
    </>
  );
};

export default Home;